import { TokenBalance } from '../../../../../../graphql/generated/graphql'

export abstract class BaseTokenModule {
    constructor(protected token: TokenBalance) {}

    sourceTokenAddress() {
        return this.token?.address
    }

    content(args: any): JSX.Element | null {
        return null
    }

    abstract paymentRequiresAllowance(): boolean
}
